import React from 'react';
import { Link } from 'react-router-dom';
import { Target, BarChart3, Search, TrendingUp, Settings, Brain, Server, MapPin, ArrowUpRight } from 'lucide-react';
import '../styles/Services.css';

const Services = () => {
  const services = [
    {
      slug: 'performance-marketing-consultant',
      icon: Target,
      title: 'Performance Marketing Consulting',
      description: 'End-to-end paid media strategy and optimization across Google Ads, Meta Ads, LinkedIn Ads, and programmatic channels. Focus on ROAS, POAS and profit-per-click.'
    },
    {
      slug: 'growth-marketing-consultant',
      icon: TrendingUp,
      title: 'Growth Marketing Consulting',
      description: 'Full-funnel growth strategy combining paid acquisition, conversion optimization, retention mechanics, and data infrastructure. Built for compounding revenue.'
    },
    {
      slug: 'paid-media-audit',
      icon: Settings,
      title: 'Paid Media Audit',
      description: 'A 10-day forensic teardown of your Google Ads, Meta and LinkedIn accounts. 40+ diagnostic checks. Prioritised remediation roadmap with dollar impact.'
    },
    {
      slug: 'ga4-gtm-attribution-consultant',
      icon: BarChart3,
      title: 'GA4, GTM & Attribution',
      description: 'Advanced analytics implementation with GA4, Google Tag Manager, BigQuery pipelines, Enhanced Conversions, and data-driven attribution.'
    },
    {
      slug: 'server-side-tracking-consultant',
      icon: Server,
      title: 'Server-Side Tracking',
      description: 'sGTM on GCP or Stape, Meta CAPI, Google Enhanced Conversions and TikTok Events API. Recover the 25–40% of ad signal browsers are killing.'
    },
    {
      slug: 'conversion-rate-optimization-consultant',
      icon: Search,
      title: 'Conversion Rate Optimization',
      description: 'Full-funnel CRO — landing pages, PDPs, checkout, onboarding. 3–5 statistically-valid experiments per week with a compounding playbook.'
    },
    {
      slug: 'ai-marketing-consulting',
      icon: Brain,
      title: 'AI Marketing Consulting',
      description: 'Agentic AI, predictive LTV models, automated personalisation and creative-at-scale workflows built on your first-party data — not off-the-shelf tools.'
    },
  ];

  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="services-header reveal">
          <div className="section-label">Consulting Services</div>
          <h2 className="section-title">Performance Marketing Consulting Services</h2>
          <div className="title-underline"></div>
          <p className="services-subtitle">
            Independent consulting services designed to scale revenue, optimize spend, and build sustainable growth systems.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => {
            const IconComponent = service.icon;
            return (
              <Link
                key={service.slug}
                to={`/${service.slug}/`}
                className="service-card reveal service-card-link"
                data-testid={`home-service-card-${service.slug}`}
              >
                <div className="service-icon-wrapper">
                  <IconComponent className="service-icon" size={32} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <span className="service-card-cta">
                  Explore this service <ArrowUpRight size={16} />
                </span>
              </Link>
            );
          })}
        </div>

        {/* Local (Kolkata) callout — internal link for local SEO */}
        <Link
          to="/performance-marketing-consultant-kolkata/"
          className="services-local-callout reveal"
          data-testid="home-service-card-kolkata"
        >
          <div className="services-local-icon">
            <MapPin size={22} />
          </div>
          <div className="services-local-body">
            <div className="services-local-eyebrow">Based in Kolkata</div>
            <h3 className="services-local-title">
              Looking for a Performance Marketing Consultant in Kolkata?
            </h3>
            <p className="services-local-desc">
              On-site across Salt Lake, New Town, Park Street and Rajarhat. Same-day access — the local advantage no US or Bangalore consultant offers.
            </p>
          </div>
          <div className="services-local-arrow">
            <ArrowUpRight size={20} />
          </div>
        </Link>
      </div>
    </section>
  );
};

export default Services;
